import { useState } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { signIn } from 'next-auth/react'
import { useSession } from 'next-auth/react'

// layout for page

import Auth from 'layouts/Auth.js'
import { useAuth } from 'context/authContext'

export default function Login() {
	const { getRedirect } = useAuth()
	const router = useRouter()
	const redirect = getRedirect()
	const [loginError, setLoginError] = useState('')
	const { status } = useSession()

	if (status === 'authenticated') {
		if (redirect !== null) {
			router.push(redirect)
		} else {
			router.push('/admin/companies')
		}
	}

	const handleSubmit = async (e) => {
		e.preventDefault()
		const res = await signIn('credentials', {
			username: e.target.username.value,
			password: e.target.password.value,
			redirect: false,
		})

		if (res.error !== null) {
			setLoginError(res.error)
		}

		if (res.ok) {
			router.push('/admin/companies')
		}
	}

	return (
		<>
			<div className='container mx-auto px-4 h-full'>
				<div className='flex content-center items-center justify-center h-full'>
					<div className='w-full lg:w-4/12 px-4'>
						<div className='relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-slate-200 border-0'>
							<div className='rounded-t mb-0 px-6 py-6'>
								<div className='text-center mb-3'>
									<h6 className='text-slate-500 text-sm font-bold'>Login</h6>
									{loginError ? loginError : ''}
								</div>
								<hr className='mt-6 border-b-1 border-slate-300' />
							</div>
							<div className='flex-auto px-4 lg:px-10 py-10 pt-0'>
								<div className='text-slate-400 text-center mb-3 font-bold'>
									<small>please enter your credentials</small>
								</div>
								<form onSubmit={handleSubmit}>
									<div className='relative w-full mb-3'>
										<label
											className='block uppercase text-slate-600 text-xs font-bold mb-2'
											htmlFor='grid-password'
										>
											Username
										</label>
										<input
											type='text'
											className='border-0 px-3 py-3 placeholder-slate-300 text-slate-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150'
											placeholder='Username'
											name='username'
											required={true}
										/>
									</div>

									<div className='relative w-full mb-3'>
										<label
											className='block uppercase text-slate-600 text-xs font-bold mb-2'
											htmlFor='grid-password'
										>
											Password
										</label>
										<input
											type='password'
											className='border-0 px-3 py-3 placeholder-slate-300 text-slate-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150'
											placeholder='Password'
											name='password'
										/>
									</div>
									{/* <div>
										<label className='inline-flex items-center cursor-pointer'>
											<input
												id='customCheckLogin'
												type='checkbox'
												className='form-checkbox border-0 rounded text-slate-700 ml-1 w-5 h-5 ease-linear transition-all duration-150'
											/>
											<span className='ml-2 text-sm font-semibold text-slate-600'>
												Remember me
											</span>
										</label>
									</div> */}

									<div className='text-center mt-6'>
										<button
											className='bg-slate-800 text-white active:bg-slate-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150'
											type='submit'
										>
											Sign In
										</button>
									</div>
								</form>
							</div>
						</div>
						<div className='flex flex-wrap mt-6 relative'>
							<div className='w-full text-center'>
								<Link legacyBehavior href='/auth/register' passHref>
									<a className='text-slate-200'>
										<small>Create new account</small>
									</a>
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

Login.layout = Auth
